import { CSSProperties } from "react"
import Icon from "src/shared/icons"
import { COLLECTION } from "src/shared/icons/Icon"
import { formatCurrency } from "src/shared/hooks/formatCurrency"
import "./DescriptionDetailTarifas.css"

interface HospedajeItem {
    rango?: string
    costo: number
    personas?: number
    costo_individual?: number
}

export interface TarifaItem {
    nombre: string
    subtotal: number
    dias: number
    hospedaje: HospedajeItem[]
}

interface Props {
    icon?: keyof typeof COLLECTION | (string & {})
    label: string
    tarifas: TarifaItem[]
    style?: CSSProperties
    className?: string
}

function DescriptionDetailTarifas({ icon, label, tarifas, style, className = "" }: Props): JSX.Element {
    return (
        <div className={`desc-tarifa ${className}`} style={style}>
            {icon && (
                <Icon
                    name={icon}
                    className="desc-tarifa__icon"
                    width={16}
                    height={16}
                    color="var(--white)"
                />
            )}
            <div className="desc-tarifa__content">
                <p className="desc-tarifa__label">{label}</p>
                {tarifas.map((tarifa, index) => {
                    const esPersonas = tarifa.hospedaje.some((h) => h.personas !== undefined)
                    const primerItem = tarifa.hospedaje[0]
                    return (
                        <div key={index} className="desc-tarifa__item">
                            <div className="desc-tarifa__item-row">
                                <p className="desc-tarifa__item-nombre">{tarifa.nombre}</p>
                                <p className="desc-tarifa__item-total">{formatCurrency(tarifa.subtotal)}</p>
                            </div>
                            {!esPersonas && (
                                <p className="desc-tarifa__item-noches">
                                    {tarifa.dias} {tarifa.dias === 1 ? "noche" : "noches"}
                                </p>
                            )}
                            {esPersonas ? (
                                <p className="desc-tarifa__item-rango">
                                    {`${primerItem?.personas ?? 0} ${(primerItem?.personas ?? 0) === 1 ? "persona" : "personas"} x noche | ${formatCurrency(primerItem?.costo_individual ?? 0)} x pers.`}
                                </p>
                            ) : (
                                tarifa.hospedaje.map((h, i) => (
                                    <p key={i} className="desc-tarifa__item-rango">
                                        {`${h.rango ?? ""} | ${formatCurrency(h.costo)}`}
                                    </p>
                                ))
                            )}
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default DescriptionDetailTarifas
